/* given div = document.querySelector('div');
  var divOffset = offset(div);
  console.log(divOffset.left, divOffset.top);
*/
function getOffset(el) {
  var rect = el.getBoundingClientRect(),
  scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
  scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}